import ErrorBasePage from "./ErrorBasePage";
export interface ErrorPageLocationState {
  errorMessage?: string;
}

export interface ErrorOptionPageProps {}


const ErrorOptionPage = () => {
  return <ErrorBasePage/>;
};

export default ErrorOptionPage
